import { render, staticRenderFns } from "./PayrollSetup.vue?vue&type=template&id=05c10356&scoped=true"
import script from "./PayrollSetup.vue?vue&type=script&lang=ts"
export * from "./PayrollSetup.vue?vue&type=script&lang=ts"
import style0 from "./PayrollSetup.vue?vue&type=style&index=0&id=05c10356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c10356",
  null
  
)

export default component.exports